module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 043.8e9cdb9f.jpg";